<script setup>
import MixGridTile from '@components/mix-grid-tile'

defineProps({
    mixes: {
        type: Array,
        default: () => [],
    },
    scroll: {
        type: Boolean,
        default: false,
    },
    scrollMobileOnly: {
        type: Boolean,
        default: false,
    },
    padded: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <div
        :class="[
            'mix-grid-block',
            scroll && 'mix-grid-block-scroll',
            scrollMobileOnly && 'mix-grid-block-scroll-mobile-only',
            padded && 'mix-grid-block-padded',
        ]"
    >
        <div
            v-for="(mix, index) in mixes"
            :key="`mix-grid-tile-${mix.id}-${index}`"
            class="tile"
        >
            <MixGridTile
                :mix="mix"
                :index="index"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.mix-grid-block {
    display: flex;
    flex-wrap: wrap;
    margin-right: -$size-grid-padding;
    margin-left: -$size-grid-padding;

    --mix-grid-columns: 2;

    @include tablet {
        --mix-grid-columns: 3;
    }

    @include desktop {
        --mix-grid-columns: 6;
    }

    &-padded {
        @include sidePadding;
    }
}

.tile {
    box-sizing: border-box;
    flex: 0 0 calc(100% / var(--mix-grid-columns));
    padding: 0 $size-grid-padding;
    margin-bottom: $size-grid-padding * 2;
}

.mix-grid-block-scroll {
    @include scrollableWrapper;
}

.mix-grid-block-scroll-mobile-only {
    padding: 0;
    .tile {
        box-sizing: content-box;
        flex-basis: 35%;

        &:first-of-type {
            margin-left: $size-grid-padding * 2;
        }
        &:last-of-type {
            padding-right: $size-grid-padding * 3;
        }

        @include tablet {
            flex-basis: 33.3333%;
        }

        @include desktop {
            box-sizing: border-box;
            flex-basis: 16.6666%;
            &:first-of-type {
                margin-left: 0;
            }
            &:last-of-type {
                padding-right: $size-grid-padding;
            }
        }
    }

    @include desktop {
        flex-wrap: wrap;
        &.mix-grid-block-padded {
            @include sidePadding;
        }
    }
}
</style>
